"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));

var _ref =
/*#__PURE__*/
_react.default.createElement("path", {
  d: "M1225.982 926.244c27.296 18.796 27.3 49.268 0 68.067l-509.835 351.074c-27.297 18.796-49.425 7.18-49.425-25.96V601.13c0-33.133 22.125-44.758 49.425-25.96l509.835 351.075z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconMiniArrowEnd =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconMiniArrowEnd, _Component);

  function IconMiniArrowEnd() {
    (0, _classCallCheck2.default)(this, IconMiniArrowEnd);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconMiniArrowEnd).apply(this, arguments));
  }

  (0, _createClass2.default)(IconMiniArrowEnd, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconMiniArrowEnd",
        viewBox: "0 0 1920 1920",
        bidirectional: true
      }), _ref);
    }
  }]);
  IconMiniArrowEnd.displayName = "IconMiniArrowEnd";
  return IconMiniArrowEnd;
}(_react.Component);

exports.default = IconMiniArrowEnd;
IconMiniArrowEnd.glyphName = 'mini-arrow-end';
IconMiniArrowEnd.variant = 'Line';
IconMiniArrowEnd.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);